import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../../../stores/session";
import ReactModal from "react-modal";

export default function ExcludeSelect({ loading, data, excludeCustomer }) {
    const { exclusionReasons, isWorkflow, uuidColumn } = useContext(ProductContext)
    const [exclusionReason, setExclusionReason] = useState(null)
    const [exclusionFeedback, setExclusionFeedback] = useState(null)
    const [modalIsOpen, setModalIsOpen] = useState(false)

    const handleSelectExclusionReason = (value) => {
        setExclusionReason(value)
        setModalIsOpen(true)
    }

    const resetExclusionModal = () => {
        setModalIsOpen(false);
        setExclusionReason(data.Occupier_Exclusion_Reason ?? '');
        setExclusionFeedback(data.Exclusion_Feedback ?? '');
    }

    const handleConfirmExclusion = async () => {
        await excludeCustomer(exclusionReason, exclusionFeedback)
        resetExclusionModal()
    }

    useEffect(() => {
        setExclusionReason(data.Occupier_Exclusion_Reason ?? '')
    }, [data[uuidColumn], isWorkflow])

    return [
        <select
            style={{ border: '1px solid var(--primary)', borderRadius: 5 }}
            onChange={_ => { handleSelectExclusionReason(_.target.value) }}
            value={(exclusionReason ?? data?.Occupier_Exclusion_Reason) ?? ''}
            disabled={data.Date_Bought || !data[uuidColumn]}
        >
            <option disabled selected value={''}>Select an exclusion reason</option>
            {exclusionReasons.map(reason => (
                <option key={reason.value} value={reason.value}>
                    {reason.label}
                </option>
            ))}
        </select>,
        <ReactModal
            className="card bulk-buy"
            isOpen={modalIsOpen}>
            <p>You have selected the following exclusion reason:</p>
            <p><strong>{exclusionReason}</strong></p>
            <div style={{ display: 'grid', marginBottom: '1em' }}>
                <p>Additional Feedback:</p>
                <textarea onChange={(event) => setExclusionFeedback(event.target.value.slice(0, 500))} value={exclusionFeedback || data.Exclusion_Feedback} rows={5} style={{ resize: 'none' }} />
                <div style={{ marginLeft: 'auto', color: 'gray', fontSize: 12 }}>
                    {exclusionFeedback?.length ?? 0}/500
                </div>
            </div>
            <div className='grid grid-columns-2 grid-gap-5'>
                <button className='button compact background-red colour-white' disabled={loading} onClick={() => resetExclusionModal(false)}>Cancel</button>
                <button className='button compact background-primary colour-white' disabled={loading} onClick={handleConfirmExclusion}>
                    {
                        loading ?
                            <i className="fa fa-spinner fa-spin" />
                            :
                            'Confirm'
                    }
                </button>
            </div>
        </ReactModal>
    ]
}